import Jackpots from "./jackpots";

export default Jackpots;
